module.exports = __webpack_public_path__ + "static/media/img_onboarding_header_bg_coach.27fb4929.png";